import { render, staticRenderFns } from "./right2.vue?vue&type=template&id=21607ea0&scoped=true"
import script from "./right2.vue?vue&type=script&lang=js"
export * from "./right2.vue?vue&type=script&lang=js"
import style0 from "./right2.vue?vue&type=style&index=0&id=21607ea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21607ea0",
  null
  
)

export default component.exports